'use strict';

import logger from './logger';

export default {
	v3ExecuteAsync: async (siteKey, action) => {
		return new Promise((resolve) => {
			window.grecaptcha.ready(() => {
				window.grecaptcha.execute(siteKey, {
					action: action
				}).then((token) => {
					return resolve(token);
				})

			})
		});
	},

	v3IsValidAsync: async (token) => {
		const data = {
			verificationToken: token
		};

		return new Promise((resolve) => {
			$.ajax({
				url: `/api/recaptcha-v3-verify`,
				data: JSON.stringify(data),
				contentType: 'application/json',
				method: 'post',
				success: () => {
					resolve(true);
				},
				error: (error) => {
					logger.error(error);
					resolve(false);
				}
			});
		});
	}
}